export default __webpack_public_path__ + "static/media/mobileBack.d0207c0e.png";